import React from 'react';
import PropTypes from 'prop-types';

var Picture = function Picture(_ref) {
  var _variants$;

  var variants = _ref.variants,
      alt = _ref.alt,
      loading = _ref.loading,
      className = _ref.className,
      imgClassName = _ref.imgClassName,
      onLoadCallback = _ref.onLoadCallback,
      width = _ref.width,
      height = _ref.height;

  if (!(variants !== null && variants !== void 0 && variants.length)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("picture", {
    className: className
  }, variants.map(function (variant, index) {
    return /*#__PURE__*/React.createElement("source", {
      key: index,
      media: "(min-width: ".concat(variant.breakpoint, "px)"),
      srcSet: variant.url
    });
  }), /*#__PURE__*/React.createElement("img", {
    width: width,
    height: height,
    onLoad: onLoadCallback,
    src: (_variants$ = variants[0]) === null || _variants$ === void 0 ? void 0 : _variants$.url,
    alt: alt,
    loading: loading,
    className: imgClassName
  }));
};

Picture.propTypes = {
  variants: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    breakpoint: PropTypes.number
  })),
  alt: PropTypes.string,
  loading: PropTypes.string,
  className: PropTypes.string,
  imgClassName: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  onLoadCallback: PropTypes.func
};
Picture.defaultProps = {
  loading: 'lazy',
  className: '',
  imgClassName: ''
};

var PictureWithStructuredData = function PictureWithStructuredData(_ref) {
  var variants = _ref.variants,
      alt = _ref.alt,
      contentUrl = _ref.contentUrl,
      license = _ref.license,
      copyright = _ref.copyright,
      caption = _ref.caption,
      loading = _ref.loading,
      className = _ref.className,
      imgClassName = _ref.imgClassName;

  if (!(variants !== null && variants !== void 0 && variants.length)) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, contentUrl && /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        '@context': 'https://schema.org/',
        '@type': 'ImageObject',
        'contentUrl': contentUrl,
        'license': license,
        'copyrightNotice': copyright,
        'description': alt,
        'caption': caption
      })
    }
  }), /*#__PURE__*/React.createElement(Picture, {
    variants: variants,
    alt: alt,
    loading: loading,
    className: className,
    imgClassName: imgClassName
  }));
};

PictureWithStructuredData.propTypes = {
  variants: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    breakpoint: PropTypes.number
  })),
  alt: PropTypes.string,
  contentUrl: PropTypes.string,
  license: PropTypes.string,
  copyright: PropTypes.string,
  caption: PropTypes.string,
  loading: PropTypes.string,
  className: PropTypes.string,
  imgClassName: PropTypes.string
};
PictureWithStructuredData.defaultProps = {
  caption: '',
  loading: 'lazy',
  className: '',
  imgClassName: '',
  copyright: 'AOK-Bundesverband GbR'
};

export { Picture, PictureWithStructuredData };
